import * as React from 'react'
import { css, SerializedStyles } from '@emotion/react'

type Props = {
  height: string
  width?: string
  color: string
  additionalStyles?: SerializedStyles
  onClick?: any
}

export const AddSignatureIcon2 = ({
  height = '20px',
  width,
  color,
  onClick = () => {},
  additionalStyles,
}: Props) => {
  return (
    <svg
      onClick={onClick}
      css={[
        css({ height: height, width: width ? width : 'auto', color: color,  cursor: 'pointer', }),
        additionalStyles,
      ]}
      viewBox="0 0 49 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.6588 30.9999C43.9564 30.9999 47.4402 27.5161 47.4402 23.2185C47.4402 18.9209 43.9564 15.437 39.6588 15.437C35.3612 15.437 31.8773 18.9209 31.8773 23.2185C31.8773 27.5161 35.3612 30.9999 39.6588 30.9999Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42 16.1993V5C42 4.17295 41.4617 2.49817 40.5035 1.91336C39.5452 1.32854 38.2456 1 36.8905 1H6.09716C4.75482 1.00192 3.46764 1.32616 2.51384 1.90262C1.56004 2.47908 1.01625 4.18082 1 5V22C1.00327 22.8244 1.54134 24.5037 2.49653 25.0867C3.45173 25.6696 4.74632 25.998 6.09716 26H32.3481"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M39.6588 19.7837V26.6534"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.2161 23.2185H43.0936"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.5911 15.8141H16.9096C17.1373 15.3683 17.3683 14.9042 17.5953 14.4312C18.6244 14.6037 19.8723 13.8526 21.3185 12.1903C21.5979 13.0314 22.1615 14.2431 23.1334 14.4271C23.8204 14.5573 24.5087 14.1763 25.2277 13.2685C25.6285 13.8253 26.5356 14.451 28.5911 14.451C28.6995 14.451 28.8035 14.4079 28.8802 14.3312C28.9569 14.2545 29 14.1505 29 14.0421C29 13.9336 28.9569 13.8296 28.8802 13.7529C28.8035 13.6762 28.6995 13.6332 28.5911 13.6332C25.8431 13.6332 25.7327 12.465 25.7286 12.3982C25.7267 12.3017 25.6907 12.2089 25.6269 12.1364C25.5632 12.0639 25.4758 12.0162 25.3803 12.002C25.2848 11.9877 25.1873 12.0077 25.1051 12.0583C25.0229 12.109 24.9614 12.1872 24.9313 12.2789C24.3002 13.2283 23.7175 13.7054 23.286 13.6236C22.9453 13.5595 22.5902 13.1377 22.289 12.4364C22.1254 12.0475 21.9966 11.645 21.9039 11.2335C21.8868 11.1505 21.8444 11.0749 21.7825 11.0171C21.7206 10.9592 21.6422 10.9221 21.5583 10.9107C21.4743 10.8993 21.3889 10.9143 21.3138 10.9536C21.2388 10.9928 21.1778 11.0544 21.1392 11.1299C19.8845 12.6906 18.7682 13.5643 17.9715 13.6277C19.5949 10.0783 20.0876 7.81969 19.4742 6.73469C19.2855 6.40074 18.8936 6 18.0955 6H18.0812C17.0589 6.00682 16.2485 7.00321 15.8533 8.73567C15.3919 10.7707 15.6529 13.2242 16.8428 14.1102C16.56 14.6997 16.2704 15.275 15.9896 15.8141H14.4152C14.3068 15.8141 14.2028 15.8571 14.1261 15.9338C14.0494 16.0105 14.0063 16.1145 14.0063 16.223C14.0063 16.3314 14.0494 16.4354 14.1261 16.5121C14.2028 16.5888 14.3068 16.6319 14.4152 16.6319H15.5575C14.7321 18.1708 14.0745 19.2667 14.0649 19.2837C14.0353 19.3298 14.0153 19.3813 14.006 19.4352C13.9967 19.4891 13.9983 19.5444 14.0107 19.5977C14.0231 19.651 14.0461 19.7013 14.0783 19.7455C14.1106 19.7898 14.1513 19.8271 14.1982 19.8553C14.2451 19.8835 14.2972 19.902 14.3514 19.9097C14.4056 19.9174 14.4608 19.9141 14.5137 19.9001C14.5666 19.8861 14.6161 19.8616 14.6594 19.828C14.7027 19.7945 14.7388 19.7526 14.7655 19.7049C14.7764 19.6872 15.5534 18.3916 16.4837 16.6319H28.5911C28.6995 16.6319 28.8035 16.5888 28.8802 16.5121C28.9569 16.4354 29 16.3314 29 16.223C29 16.1145 28.9569 16.0105 28.8802 15.9338C28.8035 15.8571 28.6995 15.8141 28.5911 15.8141ZM16.6534 8.91832C16.9437 7.64385 17.5087 6.81784 18.0955 6.81784C18.529 6.81784 18.6809 6.9889 18.7648 7.13748C19.0374 7.61455 19.1737 9.05599 17.2061 13.3394C16.5028 12.6361 16.2411 10.7244 16.6534 8.91832Z"
        fill="currentcolor"
      />
    </svg>
  )
}
